const findStoreInNearbyStores = (
  nearbyStores,
  nearbyStoreInventory,
  distanceFilter
) =>
  nearbyStores.find(
    (nearbyStore) =>
      nearbyStore.id === nearbyStoreInventory.storeId &&
      nearbyStore.distanceToStore <= distanceFilter
  );

/**
 * @param {number} distanceFilter - distance to the store
 * @param {array} nearbyStoresInventory - array of nearby stores inventory
 * @param {array} nearbyStores - array of nearby stores
 * returns array of nearbyStores with bopis quantity (if any) to each store
 */
export const filterNearbyStoresForBopisInventory = (
  distanceFilter,
  nearbyStoresInventory,
  nearbyStores
) => {
  return nearbyStoresInventory?.stores.reduce(
    (storesArray, nearbyStoreInventory) => {
      const bopisQuantity = parseInt(
        nearbyStoreInventory.inventory[0].bopisQuantity
      );
      const hasInventory = bopisQuantity > 0;

      if (hasInventory) {
        const store = findStoreInNearbyStores(
          nearbyStores,
          nearbyStoreInventory,
          distanceFilter
        );

        if (store) {
          const storeWithInventory = {
            ...store,
            bopisQuantity,
          };

          storesArray.push(storeWithInventory);
        }
      }
      return storesArray;
    },
    []
  );
};

/**
 * @param {number} distanceFilter - distance to the store
 * @param {array} nearbyStoresInventory - array of nearby stores inventory
 * @param {array} nearbyStores - array of nearby stores
 * returns array of nearbyStores with bopis quantity (if any) to each store
 */
export const filterNearbyStoresForStoreInventory = (
  distanceFilter,
  nearbyStoresInventory,
  nearbyStores
) => {
  return nearbyStoresInventory?.stores.reduce(
    (storesArray, nearbyStoreInventory) => {
      const bopisQuantity = parseInt(
        nearbyStoreInventory.inventory[0].bopisQuantity
      );
      const hasInventory =
        nearbyStoreInventory.inventory[0].quantity > 0 && bopisQuantity === 0;

      if (hasInventory) {
        const store = findStoreInNearbyStores(
          nearbyStores,
          nearbyStoreInventory,
          distanceFilter
        );

        if (store) {
          storesArray.push(store);
        }
      }
      return storesArray;
    },
    []
  );
};
